module.exports = __webpack_public_path__ + "static/media/plasmareact.e8f4b02f.png";